// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-link:focus {
  box-shadow: inset 0px 0px 0px 3px black;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/login-menu/login-menu.component.scss"],"names":[],"mappings":"AAAA;EACI,uCAAA;EACA,kBAAA;AACJ","sourcesContent":[".nav-link:focus {\n    box-shadow:inset 0px 0px 0px 3px black;\n    border-radius: 3px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
